<template>

</template>

<script>
    export default {
        name: "page2"
    };
</script>

<style scoped>

</style>
